import { render, staticRenderFns } from "./user-roles-permissions.vue?vue&type=template&id=4d72b8c7&scoped=true&"
import script from "./user-roles-permissions.vue?vue&type=script&lang=js&"
export * from "./user-roles-permissions.vue?vue&type=script&lang=js&"
import style0 from "./user-roles-permissions.vue?vue&type=style&index=0&id=4d72b8c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d72b8c7",
  null
  
)

export default component.exports